"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var constants_1 = require("./constants");
var sanitizeSpotifyURI = function (uri) {
    var spotifyParts = uri.split(':');
    if (spotifyParts.length !== 3) {
        return '';
    }
    return spotifyParts[0].toLowerCase() + ":" + spotifyParts[1].toLowerCase() + ":" + spotifyParts[2];
};
var getStyleType = function (compProps) {
    if (!compProps.showFollowersCount) {
        return compProps.size;
    }
    return compProps.size === 'small' ? "smallWithCounter" : "largeWithCounter";
};
var getPlaceholderImage = function (compProps) {
    if (compProps.size === 'small') {
        return compProps.showFollowersCount ? 'basic_show' : 'basic_hide';
    }
    if (compProps.theme === 'light') {
        return compProps.showFollowersCount
            ? 'detail_light_show'
            : 'detail_light_hide';
    }
    return compProps.showFollowersCount ? 'detail_dark_show' : 'detail_dark_hide';
};
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps;
    var _b = constants_1.DEFAULT_SIZES[getStyleType(compProps)], width = _b.width, height = _b.height, type = _b.type;
    var placeholderImage = getPlaceholderImage(compProps);
    if (compData.uri === '') {
        return { iframeSrc: null, width: width, height: height, placeholderImage: placeholderImage };
    }
    var url = new URL(constants_1.SPOTIFY_FOLLOW_URL);
    url.searchParams.append('uri', sanitizeSpotifyURI(compData.uri));
    url.searchParams.append('size', type);
    url.searchParams.append('theme', compProps.theme);
    url.searchParams.append('show-count', compProps.showFollowersCount ? '1' : '0');
    return { iframeSrc: url.toString(), width: width, height: height, placeholderImage: placeholderImage };
});
exports.css = withCompInfo_1.withCompInfo(['compProps'], function (_a) {
    var compProps = _a.compProps;
    var type = constants_1.DEFAULT_SIZES[getStyleType(compProps)].type;
    var _b = constants_1.PLACEHOLDER_DIMENSIONS[type], width = _b.width, height = _b.height;
    return {
        '--placeholder-width': width + "px",
        '--placeholder-height': height + "px",
    };
});
//# sourceMappingURL=SpotifyFollow.js.map